import { useState } from 'react';
import { searchMenuByLabel } from '../utils/search.js';

const useMenu = ({
  decoratedMenuItems
}) => {
  const [menuFiltered, setMenuFiltered] = useState(decoratedMenuItems);
  const [searchTerm, setSearchTerm] = useState('');
  const handleSearch = e => {
    const term = e.target.value;
    setSearchTerm(term);
    const filtered = searchMenuByLabel(decoratedMenuItems, term);
    setMenuFiltered(filtered);
  };
  return {
    menuFiltered,
    searchTerm,
    handleSearch
  };
};

export { useMenu };
